import React, { Component } from 'react';
import 'HELPDESK/Components/OnboardingDetails/onboardingdetails.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HelpdeskApiCall from 'HelpdeskApiCall';
import OnboardingSteps from 'HELPDESK/Components/OnboardingDetails/OnboardingSteps/OnboardingSteps';
import ButtonLoader from 'HELPDESK/CommonResources/ButtonLoader/ButtonLoader';
import SuccessModal from 'HELPDESK/CommonResources/SuccessModal/SuccessModal';
import config from 'config';

class OnboardingDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            subscriptionListFetching: false,
            subscriptionList: {},
            
            // VARIABLES TO VIEW ONBOARDING STEPS
            viewOnboardingSteps: false,
            subDetails: ''
        };
    }

    componentDidMount() {
        // METHOD CALLED TO GET ONBOARDING SUBSCRIPTION LIST
        this.apiCallToGetOnboardingSubscriptionList();
    }

    // API CALL METHOD TO GET ONBOARDING SUBSCRIPTION LIST
    apiCallToGetOnboardingSubscriptionList = async () => {
        this.setState({
            subscriptionListFetching: true
        });

        let requestData = {
            "iid": config.institute_id
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetOnboardingClientSubscriptionList',
            requestData,
            '/api/helpDesk/employee/Onboarding.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetOnboardingSubscriptionList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    subscriptionListFetching: false,
                    subscriptionList: apiResult,
                });
            } else {
                this.setState({
                    subscriptionListFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting onboarding subscription list. Please try again later.'
                });
            }
        }
    }

    // METHOD TO FOMRAT DATE
    formatDate = (d) =>{
        var date = new Date(d);

        if (isNaN(date.getTime())) {
            return "";
        }else{  
            var month = new Array();
            month[0] = "January";
            month[1] = "February";
            month[2] = "March";
            month[3] = "April";
            month[4] = "May";
            month[5] = "June";
            month[6] = "July";
            month[7] = "August";
            month[8] = "September";
            month[9] = "October";
            month[10] = "November";
            month[11] = "December";

            let day = date.getDate();
            
            if(day < 10) {
                day = "0"+day;
            }
            return day  + " " +month[date.getMonth()] + ", " + date.getFullYear();
        }       
    }

    // METHOD TO SET SUBSCRIPTION DETAILS
    setSubDetails = (sub) => {
        this.setState({
            viewOnboardingSteps: true,
            subDetails: sub
        });
    }
    
    // METHOD TO CLOSE ONBOARDING STEPS
    closeOnboardingSteps = () => {
        this.setState({
            viewOnboardingSteps: false
        }, () => {
            // API CALL TO GET ONBOARDING SUBSCRIPTION LIST
            this.apiCallToGetOnboardingSubscriptionList();
        });
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false,
        });
    }

    render() {
        return (
            <>
                {
                    this.state.viewOnboardingSteps ?
                        <div className="onboardingSubSteps col-md-12">
                            <OnboardingSteps
                                subDetails={this.state.subDetails}
                                closeOnboardingSteps={this.closeOnboardingSteps}
                            />
                        </div>
                    :
                        <div className="onboardingDetails col-md-12">
                            <div className="link-header">
                                <FontAwesomeIcon icon={['far', 'arrow-alt-circle-left']} size="lg" style={{ marginRight: 10, cursor: 'pointer' }} onClick={() => this.props.closeLinkDetails()} />
                                <p className="header-text">Onboarding Subscription List</p>
                            </div>
                            <div className="onboardSubList">
                                <table className="table table-bordered table-responsive-sm" style={{ background: '#FFF' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ padding: 5 }}>Sr. No.</th>
                                            <th style={{ padding: 5 }}>Subscription Type</th>
                                            <th style={{ padding: 5 }}>Subscription Start Date</th>
                                            <th style={{ padding: 5 }}>Subscription End Date</th>
                                            <th style={{ padding: 5 }}>Onboarding Steps</th>
                                            <th style={{ padding: 5 }}>Onboarding Completion %</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.subscriptionListFetching ?
                                                <tr>
                                                    <td colSpan="6" style={{ padding: 5 }}>
                                                        <ButtonLoader />
                                                    </td>
                                                </tr>
                                            :
                                                Object.keys(this.state.subscriptionList).length > 0 ?
                                                    Object.values(this.state.subscriptionList).map((sub, subIndex) => {
                                                        return(
                                                            <tr key={sub.unique_id}>
                                                                <td style={{ padding: 5 }}>{subIndex + 1}.</td>
                                                                <td style={{ padding: 5 }}>{sub.subscription_type.length>50 ? sub.subscription_type.substring(0,50)+"...":sub.subscription_type}</td>
                                                                <td style={{ padding: 5 }}>{this.formatDate(sub.subscription_start_date)}</td>
                                                                <td style={{ padding: 5 }}>{this.formatDate(sub.subscription_end_date)}</td>
                                                                <td style={{ padding: 5 }}>
                                                                    <span style={{ cursor: 'pointer', fontWeight: 'bold' }} title="Click to view onboarding steps" onClick={() => this.setSubDetails(sub)}><span style={{ color: '#219653' }}>{sub.completed_onboarding_steps}</span>/<span style={{ color: '#0465AC' }}>{sub.total_onboarding_steps}</span></span>
                                                                </td>
                                                                <td style={{ padding: 5, color: '#EB5757', fontWeight: 'bold' }}>
                                                                    {
                                                                        sub.completed_onboarding_steps > 0 && sub.total_onboarding_steps > 0 ?
                                                                        parseFloat((sub.completed_onboarding_steps * 100) / sub.total_onboarding_steps).toFixed(2)
                                                                        : 0
                                                                    } %
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                :
                                                    <tr>
                                                        <td colSpan="6" style={{ padding: 5 }}>No onboarding subscription found.</td>
                                                    </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                }
                {
                    this.state.successModal &&
                        <SuccessModal
                            successModal={this.state.successModal} 
                            successModalType={this.state.successModalType}
                            successMessage={this.state.successMessage}
                            closeSuccessModal={this.closeSuccessModal} 
                        />
                }
                <br />
            </>
        );
    }
}

export default OnboardingDetails;